module.exports = __webpack_public_path__ + "public/adminIcons/last-24-hrs-users.png?46dcc951";